/*
 * @providesModule HowToLevelUpModalStyle
 *
 */

import SkillzStyle from 'SkillzStyle';

import {StyleSheet} from 'react-native';

const {
  btnTextColorOne,
  tabHighlightColor,
  fontSizeH3,
  fontSizeH4,
  fontSizeH5,
  fontSecondary,
  fontMedium,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  modalBody: {
    paddingVertical: 30,
    marginTop: 30,
    justifyContent: 'center',
    alignItems: 'center',
  },

  diagramContainer: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
  },

  iconAndTitle: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },

  diagramIcon: {
    width: 34,
    height: 34,
  },

  diagramLabel: {
    color: '#4A4A4A',
    ...fontSizeH5,
    ...fontMedium,
    textAlign: 'center',
    marginTop: 5,
  },

  diagramProgressOuterContainer: {
    marginTop: 12,
    justifyContent: 'center',
    width: '100%',
  },

  diagramProgressContainer: {
    width: '100%',
    alignSelf: 'center',
    flexDirection: 'row',
    alignItems: 'center',
  },

  diagramProgressLine: {
    position: 'absolute',
    bottom: 5.5,
    left: '15%',
    right: '15%',
    height: 1,
    backgroundColor: tabHighlightColor.color,
  },

  diagramShape: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },

  circle: {
    width: 12,
    height: 12,
    backgroundColor: tabHighlightColor.color,
    borderRadius: 6,
  },

  triangle: {
    width: 0,
    height: 0,
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    borderLeftWidth: 6,
    borderRightWidth: 6,
    borderBottomWidth: 12,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: tabHighlightColor.color,
    transform: [{rotate: '90deg'}],
  },

  caption: {
    ...fontSizeH4,
    color: '#4A4A4A',
    marginVertical: 32,
  },

  button: {
    width: 164,
    height: 35,
    alignSelf: 'center',
  },

  buttonText: {
    ...fontSizeH3,
    ...btnTextColorOne,
    ...fontSecondary,
  },
});
